import React from 'react'

export const About = () => (
    <div>
        <h1>About Team Sorters</h1>
    </div>
)